import _ from 'lodash';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const propTypes = {
  title: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  children: PropTypes.element.isRequired,
  isOpen: PropTypes.bool,
  popClassName: PropTypes.string,
  placement: PropTypes.string
};
const defaultProps = {
  isOpen: false,
  message: null,
  popClassName: '',
  title: '',
  placement: 'top'
};

// TODO: v3. Fix to get hover message working with old and new bootsrap/react-bootstrap.
const PopoverTitle = Popover.Header;
const PopoverContent = Popover.Body;
const getPopover = (title, message, popClassName) => {
  return (
    <Popover id="popover-basic" className={popClassName}>
      <PopoverTitle as="h3">{_.startCase(title)}</PopoverTitle>
      <PopoverContent>
        {message}
      </PopoverContent>
    </Popover>
  );
};

const HoverMessage = (props) => {
  const {
    title, message, isOpen, children, popClassName, placement
  } = props;
  const getIsShow = isOpen ? { show: true } : {};

  return (
    <OverlayTrigger
      placement={placement}
      {...getIsShow}
      delay={{ show: 250, hide: 400 }}
      overlay={getPopover(title, message, popClassName)}
    >
      {children}
    </OverlayTrigger>
  );
};

HoverMessage.propTypes = propTypes;
HoverMessage.defaultProps = defaultProps;

export default HoverMessage;
